import axios from 'axios'
import { levelUrl, getHeader } from '@/config'

const state = {
  levelList: []
}

const mutations = {
  SET_LEVEL_LIST (state, obj) {
    state.levelList = obj
  }
}

const actions = {
  getLevelList: ({ commit }) => {
    axios.get(levelUrl, { headers: getHeader() })
      .then(response => {
        console.log(response.data.data)
        commit('SET_LEVEL_LIST', response.data.data)
      })
  }
}

export default {
  state, mutations, actions
}
